module.exports = __webpack_public_path__ + "static/media/facebook.adf288bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/facebook.svg
// module id = 1169
// module chunks = 0